export default (block) => {
  if (block.marketoForm && block.marketoForm.length) {
    block.marketoFormProps = block.marketoForm[0]
  }

  return block
}
